import { AbstractControl } from '@angular/forms';
import { RBCheck, ViewModelProperty } from '@ldw/roesberg';
import { KeyValuePair } from '../shared/models/key-value-pair';
import { NavigationMode } from '../shared/enums/navigation-mode';
import { Base64 } from 'js-base64';

export class SearchOptions {
  webDokuId = '';
  searchMetaData = false;
  isTokenSearch = false;
  isWildCard = false;
  searchValues: KeyValuePair[] = [];
  navigationMode: NavigationMode = NavigationMode.Documents;

  // force change of routeparam
  rValue = Math.floor(Math.random() * 10000);

  // deserialization ignores function code, so we
  // copy restored data into new object
  public static fromJson(json: string): SearchOptions {
    const options = new SearchOptions();
    if (RBCheck.isNullOrEmpty(json)) {
      return options;
    }
    const decoded = JSON.parse(Base64.decode(json)) as SearchOptions;
    options.searchValues = decoded.searchValues;
    options.isTokenSearch = decoded.isTokenSearch;
    options.isWildCard = decoded.isWildCard;
    options.searchMetaData = decoded.searchMetaData;
    options.navigationMode = decoded.navigationMode;
    options.webDokuId = decoded.webDokuId;
    return options;
  }

  public addValuesFromVMPList(vmpList: ViewModelProperty[] | undefined) {
    if (vmpList == undefined || vmpList.length == 0) {
      return;
    }
    vmpList.forEach((vmp) => {
      this.addValueFromVMP(vmp);
    });
  }

  public addValueFromVMP(vmp: ViewModelProperty | undefined) {
    if (
      vmp == undefined ||
      vmp.fieldName == undefined ||
      vmp.fieldName == '' ||
      vmp.value == undefined ||
      vmp.value == ''
    ) {
      return;
    }
    this.searchValues.push(KeyValuePair.fromValues(vmp.fieldName, vmp.value));
  }

  public addValueFromControl(field: ViewModelProperty | undefined, control: AbstractControl | undefined) {
    if (
      field == undefined ||
      field.fieldName == undefined ||
      field.fieldName == '' ||
      control == undefined ||
      control.value == undefined ||
      control.value == ''
    ) {
      return;
    }
    this.searchValues.push(KeyValuePair.fromValues(field.fieldName, control.value));
  }

  public addValue(fieldName: string, value: string) {
    if (fieldName == undefined || value == undefined) {
      return;
    }
    this.searchValues.push(KeyValuePair.fromValues(fieldName, value));
  }

  public addSearchText(value: string) {
    this.addValue('FILTERNAME_LUCENESEARCH', value);
  }

  public getSearchText(): string {
    return this.searchValues.find((s) => s.key === 'FILTERNAME_LUCENESEARCH')?.value ?? '';
  }

  getSearchHeader(): string {
    if (this.searchValues == undefined || this.searchValues.length == 0) {
      return '';
    }

    let text = '';
    this.searchValues.forEach((vmp) => {
      if (vmp.value != undefined && vmp.value != '') {
        if (text != '') {
          text += ',';
        }
        text += vmp.value;
      }
    });
    return text;
  }
}
